import { Editor } from '@tiptap/react';
import { FC } from 'react';

import { type EditorToolbarItem } from './editorActions';
import ToolbarButton from './ToolbarButton';

interface EditorToolbarProps {
  editor: Editor | null;
  items: EditorToolbarItem[];
}

const EditorToolbar: FC<EditorToolbarProps> = ({ editor, items }) => {
  if (!editor) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-x-0.5 border-b border-gray-200 p-2 align-middle dark:border-gray-700">
      {items.map((item) => (
        <ToolbarButton key={item} editor={editor} item={item} />
      ))}
    </div>
  );
};

export default EditorToolbar;
